import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useUserSignupEvent = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const handleTrackUserSignupEvent = useCallback(
    (signupData) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (signupData) {
          const { email, phoneNumber, firstName, lastName } = signupData;
          // Log the user signup event with WebEngage
          window.webengage.track("sign_up", {
            email,
            phone: phoneNumber,
            firstName,
            lastName,
          });
        } else {
          console.warn("Signup data is required to track user signup event");
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { handleTrackUserSignupEvent };
};

export default useUserSignupEvent;
